import { type UseQueryResult, useQuery } from 'react-query';
import { GrantService } from '@wealthlane/api-services/wealthlane-award-service';
import { PdfFormFieldFillupService } from '@wealthlane/api-services/wealthlane-customer-service';

const useGetBrokeragePdfAvailableSources = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const brokeragePdfAvailableSources = useQuery(
    ['brokeragePdfAvailableSources'],
    async () => {
      return await handleRequest(
        PdfFormFieldFillupService.getApiCustomerApiBrokeragePdfAvailableSources()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item ?? '',
            value: item ?? '',
          };
        });
      },
    }
  );

  return brokeragePdfAvailableSources;
};

export default useGetBrokeragePdfAvailableSources;
